import { useState } from 'react'
import CardCostCampaing from '../../Molecules/CardCostCampaing/CardCostCampaing';
import FormCampaing from '../../Organisms/FormCampaing/FormCampaing';
import GroupOfButtons from '../../Molecules/GroupOfButtons/GroupOfButtons';
import HeaderTitle from '../../Molecules/HeaderTitle/HeaderTitle';
import CampaingAssignmentProfileOperatos from '../../Organisms/CampaingAssignmentProfileOperatos/CampaingAssignmentProfileOperatos';
import CampaingAssociateClients from '../../Organisms/CampaingAssociateClients/CampaingAssociateClients';
import CampaingAssociateProducts from '../../Organisms/CampaingAssociateProducts/CampaingAssociateProducts';
import CampaingQuestionsAndAnswers from '../../Organisms/CampaingQuestionsAndAnswers/CampaingQuestionsAndAnswers';
import './EditCampaing.scss';
import ScriptCampaing from '../../Organisms/ScriptCampaing/ScriptCampaing';

const EditCampaing = () => {
  const [formsHandler, setFormsHandler] = useState({
    showForm1: true,
    showForm2: false,
    showForm3: false,
    showForm4: false,
    showForm5: false,
    showForm6: false,
  });

  return (
    <div className="nd-grid">
       <HeaderTitle
        headerText="Editar campaña"
        withDivider
      />
      <div>
        <h3 className="mb-5 poppins-28 line-clamp mb-30">Nombre de la campaña creadare max. 70 caracteres campaña campaña campaña campaña campaña</h3>
        
        <CardCostCampaing cost={12} balance={15} />

        <GroupOfButtons
          content={{ 
            first: "Datos de campaña", 
            second: "Asociar perfiles", 
            third: "Asociar clientes", 
            four: "Asociar productos", 
            five : "Base de conocimiento",
            sixth: "Script"
          }}
          formsHandler={formsHandler}
          customClass="mt-30"
          setFormsHandler={setFormsHandler} />
        
        {
          formsHandler.showForm1 && 
          <div className="box s-pxy-20 m-pxy-50 mt-30">
            <FormCampaing />
          </div>
        }

        {
          formsHandler.showForm2 && 
          <CampaingAssignmentProfileOperatos />
        }
        {
          formsHandler.showForm3 && 
          <CampaingAssociateClients />
        }
        {
          formsHandler.showForm4 && 
          <CampaingAssociateProducts />
        }
        {
          formsHandler.showForm5 && 
          <CampaingQuestionsAndAnswers />
        }
        {
          formsHandler.showForm6 && 
          <ScriptCampaing />
        }
        
      </div>
    </div>
  )
}

export default EditCampaing
